import { Routes } from '@angular/router';
import { SidebarLayoutComponent } from '@layouts/sidebar-layout/sidebar-layout.component';

export const routes: Routes = [
  { path: '', loadChildren: () => import('@public/public.module').then(m => m.PublicModule) },
  { path: '', component: SidebarLayoutComponent, children: [
    { path: 'apps', loadChildren: () => import('@apps/apps.module').then(m => m.AppsModule) },
    { path: 'settings', loadChildren: () => import('./private/private.module').then(m => m.PrivateModule) },
    { path: 'admin', loadChildren: () => import('@admin/admin.module').then(m => m.AdminModule) },
  ] },
];